import styled from 'styled-components';
import COLORS from '@mlb/react-patterns/v4/style/universal.color';
import { StyledBaseSkeleton } from '@mlb/react-patterns/v4/components/Skeleton/skeleton.style';

const {
    mlbGrey4
} = COLORS;

const extractBallColorByType = ({ $color = mlbGrey4, $isBall, $isStrike, $isInPlay, $isInPlayOuts }) => {
    let ballColor = $color;

    switch (true) {
    case $isBall:
        ballColor = 'var(--gameday-ball-color-ball)';
        break;
    case $isStrike:
        ballColor = 'var(--gameday-ball-color-strike)';
        break;
    case $isInPlayOuts:
        ballColor = 'var(--gameday-ball-color-in-play-outs)';
        break;
    case $isInPlay:
        ballColor = 'var(--gameday-ball-color-in-play)';
        break;
    }

    return ballColor;
};

export const PlayPitchWrapper = styled.div`
  position: relative;
  color: var(--gameday-primary-font-color);
  padding-left: ${({ $offset }) => $offset ? '0px' : '46px'};
  margin-left: ${({ $offset }) => $offset ? '46px' : '-46px'};
  width: 100%;
  min-height: 32px;
  box-sizing: content-box;
  ${StyledBaseSkeleton} {
    &:first-child {
      position: absolute;
      left: ${({ $offset }) => !$offset ? '0px' : '-45px'};;
    }
  }
`;

export const PitchNumberWrapper = styled.div`
  position: absolute;
  left: ${({ $offset }) => !$offset ? '0px' : '-46px'};;
  font-variant-numeric: tabular-nums;
  text-align: center;
  box-sizing: content-box;
  width: 28px;
  height: 28px;
  line-height: 29px;
  vertical-align: middle;
  background-color: ${extractBallColorByType};
  font-size: 18px;
  border-radius: 50%;
  border: 2px solid var(--gameday-background-color);
  font-weight: bold;
  color: var(--gameday-ball-text-color);
  box-shadow: inset 0px 0px 0px 1px var(--gameday-ball-stroke-color);
  background-clip: content-box;
`;

export const PitchHeaderWrapper = styled.div`
  font-weight: bold;
  font-size: 14px;
  line-height: 14px;
  padding-bottom: 4px;
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-top: ${({ $singleLine, $noPitch }) => $singleLine ? '8px' : $noPitch ? '2px' : '0px'};

`;

export const PitchDetailsWrapper = styled.div`
  font-size: 14px;
  line-height: 14px;
  position: relative;
`;

export const PitchSpeedWrapper = styled.div`
  display: inline-block;
  font-weight: bold;
  margin-right: 4px;
`;

export const CountWrapper = styled.div`
  font-feature-settings: 'tnum';
  min-width: fit-content;
`;
